module.exports = __webpack_public_path__ + "static/media/hr.8f6905ab.svg";